import '../css/navigation.css'
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from '../img/logo2-01.svg';
import Github from '../img/github.svg'
import LinkedIn from '../img/linkedin.svg'

export default function Navigation() {
  const [isChecked, setIsChecked] = useState(false);

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  }

  return (
    <nav id={`${isChecked}`}>
      <input type="checkbox" id="trigger" checked={isChecked}/>
      <div className="main-nav">
        <div className="centerbox">
          <Link to={"/"} className="back-trigger" onClick={handleOnChange}>Back</Link>
          <Link to={"portfolio"} className="forward-trigger" onClick={handleOnChange}>Coba</Link>
          <h3>Find my work <img src="click.svg" alt="" className="clickArrow"/></h3>
          <img src={Logo} alt="Logo" className="logo"/>
          {/* <h4>LuthfiNr</h4> */}
          <ul>
            <NavLink to={"portfolio"} className="nav-link">Portfolio</NavLink>
            <NavLink to={"contact"} className="nav-link" style={{display:'none'}}>Contact</NavLink>
            <NavLink to={"about"} className="nav-link">About</NavLink>
          </ul>
          <div className="account">
            <a href="https://github.com/LuthfiDbz" target={"_blank"} rel={"noreferrer"}><img src={Github} alt="" /></a>
            <a href="https://www.linkedin.com/in/luthfinoer/" target={"_blank"} rel={"noreferrer"}><img src={LinkedIn} alt="" /></a>
          </div>
        </div>
      </div>
    </nav>
  )
}
